// removed by extract-text-webpack-plugin
module.exports = {"collapse":"src-components-HomeTextCollapse----HomeTextCollapse-module---collapse---3lN2_","expand":"src-components-HomeTextCollapse----HomeTextCollapse-module---expand---2t5Ks","collapse__toggle_wrapper":"src-components-HomeTextCollapse----HomeTextCollapse-module---collapse__toggle_wrapper---JYHsp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeTextCollapse/HomeTextCollapse.module.scss
// module id = 861
// module chunks = 35783957827783